import React, { useEffect } from "react";
import { Modal, Card } from "semantic-ui-react";
import push_pin from "../../assets/images/push_pin.svg";
import pdfimage from "../../assets/images/download.jpg";

const PinnedDocsPopup = ({ contentPopup }) => {
  useEffect(() => {
    console.log("pinned data uwu", contentPopup);
  }, []);
  return (
    <>
      <Modal.Header>
        <div className="unpinpopup">
          <div className="imageforunpin">
            <button className="ml-auto w-8 h-8 bg-gray-200 rounded-full rotate-45 imageunpin">
              <img className="h-7 m-[2px]" src={push_pin} alt="push pin logo" />
            </button>
          </div>
          <div>
            <h3> Unpin the document?</h3>
          </div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="popupPin">
          <Card style={{ width: "400px" }}>
            <Card.Content className="cardheader">
              <div className="titleofcard">
                {contentPopup.procedureTitle
                  ? contentPopup.procedureTitle
                  : contentPopup?.title}
              </div>
            </Card.Content>

            <Card.Content extra className="pdfimagewrapper">
              <div className="pdfimage">
                {contentPopup?.procedureTitle ? (
                  <div className="xauth-tag-icon">
                    <a className="xauth-icon" id="unpin-popup">
                      Xauth
                    </a>
                  </div>
                ) : (
                  <img src={pdfimage} alt="no image" />
                )}
              </div>
              <div className="right-div">
                <div className="filetype">
                  {" "}
                  {contentPopup?.procedureTitle
                    ? "Xauthor File"
                    : "Original File"}
                </div>
                <div className="linktoredirect">
                  {contentPopup.procedureTitle
                    ? contentPopup.procedureTitle
                    : contentPopup?.file_name}
                </div>
              </div>
            </Card.Content>
          </Card>
        </div>
      </Modal.Content>
    </>
  );
};

export default PinnedDocsPopup;